import { render, staticRenderFns } from "./DialogHeaderNew.vue?vue&type=template&id=8bb8db4c&scoped=true&"
import script from "./DialogHeaderNew.vue?vue&type=script&lang=js&"
export * from "./DialogHeaderNew.vue?vue&type=script&lang=js&"
import style0 from "./DialogHeaderNew.vue?vue&type=style&index=0&id=8bb8db4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb8db4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VCardTitle,VDivider})
